import * as React from "react";
import BootstrapSpinner from "react-bootstrap/Spinner";

export const Spinner: React.FC<{loadingText?: string}> = (props) => {
    return <div className={'loading'}>
        <BootstrapSpinner animation="border" variant="secondary" />
        {props.loadingText ? <div className='loading-text'>{props.loadingText}</div> : null}
    </div>
};
